export const BAR_LAYOUT_I18N = {
    BACK: 'Terug',
    HOME: 'Home',
    MAINSCREEN: 'Startscherm',
    TITLE: 'E-loket Landbouw en Zeevisserij',
    HEADER_TITLE: '<i>E-loket</i>Departement <em>Landbouw & Visserij</em>',
    HEADER_LINK_TITLE: 'Landbouw en Zeevisserij Vlaanderen',
    CLOSE_COMPACT_MODUS: 'Sluit compacte modus',
    MENU: {
        OVERLAY_OPEN_BTN: 'Open een overlappend menu en klik erbuiten om het te sluiten',
        CLOSE_MENU: 'Klik hier om het menu te sluiten',
        COLLAPSE_MENU: 'Klap het menu weg',
        PIN_MENU: 'Pin het menu vast',
        OPEN: 'Open het menu'
    },
    EDIT_PAGE: {
        LOADING: 'Laden...',
        ACTION: {
            SAVE: 'Opslaan',
            UNDO: 'Ongedaan maken',
            DELETE: 'Verwijderen',
            EDIT: 'Wijzigen'
        },
        ARE_YOU_SURE_DELETE: 'Bent u zeker dat u deze gegevens wilt verwijderen?',
        ARE_YOU_SURE_UNDO: 'Bent u zeker dat u eventuele wijzigingen ongedaan wilt maken?',
        ARE_YOU_SURE_SAVE: 'Bent u zeker dat u de wijzigingen wilt bewaren?',
        ARE_YOU_SURE_AUTOSAVE_NON_BLOCKING: 'Er zijn wijzigingen aangebracht. Wilt u deze bewaren voordat u de pagina verlaat?',
        CONFIRM_TITLE_NON_BLOCKING: 'Bewaren',
        CONFIRM_TRUE_NON_BLOCKING: 'Bewaren',
        CONFIRM_FALSE_NON_BLOCKING: 'Niet bewaren',
        ARE_YOU_SURE: 'Bent u zeker?',
        MESSAGE: {
            SAVE: 'De gegevens werden bewaard',
            UNDO: 'De gegevens werden ongedaan gemaakt',
            DELETE: 'De gegevens werden verwijderd',
            LEAVE_PAGE:
                'Opgelet, uw wijzigingen zijn niet opgeslagen: bent u zeker dat u deze pagina wilt afsluiten? Niet bewaarde gegevens zullen verloren gaan.',
            INVALID: 'Gelieve de schermvalidatie(s) op te lossen',
            INVALID_AUTOSAVE: 'Gelieve de schermvalidatie(s) op te lossen of de wijzigingen ongedaan te maken'
        }
    },
    OFFCANVAS: {
        PIN: 'Vastzetten',
        UNPIN: 'Losmaken',
        CLOSE: 'Sluiten'
    }
} as const;
